import { useParams } from '@tanstack/react-router';
import { useSession } from '../lib/session';
import { ChannelView } from '../components/ChannelView';
import { useLayout } from './app-layout';

export function ChannelRoute() {
  const { channelId } = useParams({ from: '/app/c/$channelId' });
  const session = useSession();
  const { sidebarCollapsed, expandSidebar } = useLayout();

  if (!session.data) return null;

  return (
    <ChannelView
      key={channelId}
      channelId={channelId}
      me={session.data.user}
      sidebarCollapsed={sidebarCollapsed}
      onExpandSidebar={expandSidebar}
    />
  );
}
